import React from 'react';

// Tipos e gravidades das ocorrências (iguais aos do servidor)
export const TIPOS_OCORRENCIA = {
    DISCIPLINAR: { label: 'Disciplinar', icone: '⚠️', cor: '#dc2626', fundo: '#fde8e8' },
    PEDAGOGICA: { label: 'Pedagógica', icone: '📚', cor: '#2563eb', fundo: '#e8f0fe' },
    ELOGIO: { label: 'Elogio', icone: '⭐', cor: '#16a34a', fundo: '#e3f4ec' },
    SAUDE: { label: 'Saúde', icone: '🩺', cor: '#0891b2', fundo: '#e0f5fa' },
    ATRASO_SAIDA: { label: 'Atraso/Saída antecipada', icone: '⏰', cor: '#d97706', fundo: '#fff4e5' },
    OUTRA: { label: 'Outra', icone: '📌', cor: '#7c3aed', fundo: '#f1ebfd' },
};

export const GRAVIDADES = {
    LEVE: { label: 'Leve', cor: '#16a34a' },
    MEDIA: { label: 'Média', cor: '#d97706' },
    GRAVE: { label: 'Grave', cor: '#dc2626' },
};

export const dataBR = (s) => String(s || '').split('-').reverse().join('/');
export const dataHoraBR = (dt) => {
    if (!dt) return '';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '';
    return `${d.toLocaleDateString('pt-BR')} às ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
};

const chip = (cor, fundo) => ({
    display: 'inline-flex', alignItems: 'center', gap: 4, padding: '2px 9px', borderRadius: 999,
    fontSize: 12, fontWeight: 800, color: cor, background: fundo || 'transparent', border: `1px solid ${cor}`,
    whiteSpace: 'nowrap',
});

/**
 * Cartão de uma ocorrência (escola e portal dos pais).
 * paraPais: esconde o que é interno (visibilidade) e mostra o botão "Ciente".
 */
export function CartaoOcorrencia({ o, paraPais = false, onEditar, onExcluir, onCiente, cienteCarregando }) {
    const t = TIPOS_OCORRENCIA[o.tipo] || TIPOS_OCORRENCIA.OUTRA;
    const g = GRAVIDADES[o.gravidade];
    return (
        <div className="ocorrencia-card" style={{
            border: '1px solid var(--line, #e3e8eb)', borderLeft: `4px solid ${t.cor}`, borderRadius: 10,
            padding: '10px 12px', background: 'var(--surface, #fff)', color: 'var(--text, #16323b)',
            breakInside: 'avoid', pageBreakInside: 'avoid',
        }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 6, marginBottom: 6 }}>
                <strong style={{ fontSize: 14 }}>{dataBR(o.data)}</strong>
                <span style={chip(t.cor, t.fundo)}>{t.icone} {t.label}</span>
                {o.tipo !== 'ELOGIO' && g && <span style={chip(g.cor)}>{g.label}</span>}
                {!paraPais && o.visivelPais === false && <span style={chip('#5b6b72')}>🔒 Só a escola vê</span>}
                {o.responsavelChamado && <span style={chip('#7c3aed')}>Responsável chamado</span>}
            </div>
            <div style={{ fontSize: 14, whiteSpace: 'pre-wrap', lineHeight: 1.45 }}>{o.descricao}</div>
            {o.providencia && (
                <div style={{ fontSize: 13.5, marginTop: 6, whiteSpace: 'pre-wrap' }}>
                    <strong>Providência:</strong> {o.providencia}
                </div>
            )}
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10, marginTop: 8, fontSize: 12.5, color: 'var(--text-muted, #5b6b72)' }}>
                {o.registradoPorNome && <span>Registrado por {o.registradoPorNome}</span>}
                {o.visivelPais !== false && (
                    o.ciencia
                        ? <span style={{ color: '#16a34a', fontWeight: 700 }}>✔ Ciente: {o.ciencia.nome ? `${o.ciencia.nome}, ` : ''}{dataHoraBR(o.ciencia.em)}</span>
                        : <span style={{ color: '#d97706', fontWeight: 700 }}>Aguardando ciência do responsável</span>
                )}
                <span style={{ flex: 1 }} />
                {paraPais && !o.ciencia && onCiente && (
                    <button type="button" className="nao-imprimir" disabled={cienteCarregando} onClick={() => onCiente(o)} style={{
                        padding: '7px 14px', borderRadius: 8, border: 'none', background: '#16a34a', color: '#fff', fontWeight: 800, cursor: 'pointer',
                    }}>{cienteCarregando ? 'Salvando…' : '✔ Estou ciente'}</button>
                )}
                {!paraPais && o.podeAlterar && onEditar && (
                    <button type="button" className="nao-imprimir" onClick={() => onEditar(o)} style={{ border: '1px solid var(--line, #d0d7db)', background: 'transparent', color: 'var(--text, #16323b)', borderRadius: 8, padding: '5px 12px', fontWeight: 700, cursor: 'pointer' }}>Editar</button>
                )}
                {!paraPais && o.podeAlterar && onExcluir && (
                    <button type="button" className="nao-imprimir" onClick={() => onExcluir(o)} style={{ border: '1px solid #dc2626', background: 'transparent', color: '#dc2626', borderRadius: 8, padding: '5px 12px', fontWeight: 700, cursor: 'pointer' }}>Excluir</button>
                )}
            </div>
        </div>
    );
}
